import IspContext from '../contexts/IspContext';
import { useContext } from 'react';

const useIsp = () => {
  const context = useContext(IspContext);
  return context;
};

export default useIsp;
